import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { PricingFailedIndicator, SText } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';

interface PriceProps extends Pick<
  STextProps,
  'weight' | 'size' | 'style' | 'fontColor'
> {
  value: number;
  loading?: boolean;
  highlight?: boolean;
  prefix?: string;
  /**
   * Pricing ran for this product and produced nothing usable, so the missing
   * value is a failure — not simply a product nobody has priced yet (DEV-495).
   */
  failed?: boolean;
  /** Re-runs pricing for this product. */
  onRetry?: () => void;
}

export const Price = ({
  value,
  loading,
  highlight,
  prefix = '',
  failed,
  onRetry,
  ...rest
}: PriceProps) => {
  if (loading) return <Skeleton />;

  if (!Number.isFinite(value)) {
    if (!failed) return <>-</>;

    return (
      <Box display="flex" alignItems="center" gridGap={4}>
        <span>-</span>
        <PricingFailedIndicator inline failed onRetry={onRetry} />
      </Box>
    );
  }

  return (
    <SText
      lineHeight="24px"
      title={`${prefix}${value.toLocaleString('en-US', {
        currency: 'USD',
        style: 'currency'
      })}`}
      color={highlight ? 'primary' : 'textPrimary'}
      {...rest}
    />
  );
};
